var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop } from 'vue-property-decorator';
import Chip from '../Chip/Chip';
import withRender from './SimpleChip.html';
let SimpleChip = class SimpleChip extends Chip {
    /**
     * Creates the requied styling classes for chip.
     * @param chip - Current chip
     */
    classObject() {
        const chipStyle = this.chipStyle ? this.chipStyle : '';
        const colorClass = chipStyle ? 'mdc-chip--' + chipStyle : '';
        return [colorClass];
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], SimpleChip.prototype, "removable", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], SimpleChip.prototype, "text", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], SimpleChip.prototype, "chipStyle", void 0);
SimpleChip = __decorate([
    withRender,
    Component
], SimpleChip);
export default SimpleChip;
//# sourceMappingURL=SimpleChip.js.map